'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import { lang, tr } from '../../utils/helpers';
import { companyUnity } from '../../modules/select';

const presencesIndex = {
  init() {
    const $counter = $('#counter');
    const $enrollment = $('#enrollment');
    const $guestsTable = $('#guests-table');
    const $messageLabel = $('.c-message--label');
    const $newGuest = $('#new-guest');
    const $results = $('#js-results');
    const $searchPanel = $('.c-search--panel');
    const $searchPanelMessage = $('.c-search--panel-message');
    const $subscribesTable = $('#subscribes-table');
    const $presenceList = $("#presence-list");
    const $presenceAdd = $("#presence-add");
    const $errorMsg = $('.js-participantes-error');
    const $selectCompany = $("select[name='company_id']");
    const $selectUnity = $("select[name='unity_id']");
    const $inputAddGuests = $('.js-input-add-guests');
    const $inputName = $("input[name='name']");
    const $inputEmail = $("input[name='email']");
    const $inputVolunteerType = $("input[name='volunteer_type']");
    const $inputCpf = $("input[name='cpf']");

    companyUnity();

    function resetEmployeeFields() {
      $inputCpf.val('');
      $selectCompany.val('').trigger('change');
      $selectUnity.empty().append(`<option value="">${tr[lang].select_unities_placeholder}</option>`);
    }

    function resetAddGuestsForm() {
      $inputName.val('');
      $inputEmail.val('');
      $inputVolunteerType.prop('checked', false);
      resetEmployeeFields();
    }

    function openAddGuestsForm(e) {
      e.preventDefault();
      $inputAddGuests.val('');
      $results.html('');
      $newGuest.removeClass('u-display--none');
      $searchPanelMessage.addClass('u-display--none');
    }

    function closeAddGuestsForm(e) {
      e.preventDefault();
      $searchPanel.addClass('u-display--none');
      $newGuest.addClass('u-display--none');
      $enrollment.addClass('u-display--none');
      resetAddGuestsForm();
    }

    $('.js-check-volunteers').on('click', function (e) {
      e.preventDefault();

      $errorMsg.hide();

      let employees = $('.employee').filter(':checked').length;
      let externals = $('.external').filter(':checked').length;

      $('#js-total-employees').html(employees);
      $('#js-total-external').html(externals);
    });

    $('.js-presence-validate').on('click', function (e) {
      if ($('.employee').filter(':checked').length <= 0 && $('.external').filter(':checked').length <= 0) {
        e.preventDefault();
        $errorMsg.show();
      } else {
        $errorMsg.hide();
      }
    });

    $('.js-checkall').on('click', function (e) {
      e.preventDefault();
      if (!$("input[name='js-checkall']").prop('checked')) $('input[type=checkbox]').prop('checked', true);
      else $('input[type=checkbox]').prop('checked', false);
    });

    $('.js-form-search').on('keyup', function (e) {
      e.preventDefault();
      w3.filterHTML('.c-new-table', '.subscribe-user', $(this).val());
    });

    $('.js-adduser').on('click', function (e) {
      e.preventDefault();
      $presenceList.removeClass('active');
      $presenceAdd.addClass('active');
    });

    $('.js-cancell-adduser').on('click', function (e) {
      e.preventDefault();
      $presenceList.addClass('active');
      $presenceAdd.removeClass('active');
      $guestsTable.html('');
    });

    $(document).on('click', '.js-close-panel', function (e) {
      closeAddGuestsForm(e);
    });

    $(document).on('click', '.js-new-guest', function (e) {
      openAddGuestsForm(e);
    });

    $(document).on('keyup', '.js-input-add-guests', function (e) {
      e.preventDefault();
      $searchPanelMessage.removeClass('u-display--none');

      if ($(this).val().length >= 1) {
        $searchPanel.removeClass('u-display--none');
      } else {
        $searchPanel.addClass('u-display--none');
      }

      if ($(this).val().length >= 3) {
        $messageLabel.addClass('u-display--none');

        var post = {};

        post.term = $(this).val();
        post._token = $('meta[name="csrf-token"]').attr('content');
        post.challenge_id = $(this).attr('data-challenge');

        $.ajax({
          type: 'POST',
          url: '/pesquisa-voluntarios/' + post.term,
          data: post,
          dataType: 'json',
          success: function (data) {
            $results.html(data.html);
          },
        });
      } else {
        $newGuest.addClass('u-display--none');
        $messageLabel.removeClass('u-display--none');
        $results.html('');
      }
    });

    $(document).on('change', '.js-volunteer-type', function () {
      if ($inputVolunteerType.filter(':checked').val() === 'employee') {
        $enrollment.removeClass('u-display--none');
      } else {
        $enrollment.addClass('u-display--none');
        resetEmployeeFields();
      }
    });

    $(document).on('click', '.js-add-presence', function (e) {
      e.preventDefault();

      var post = {};

      post.challenge_id = $(this).attr('data-challenge');
      post.user_id = $(this).attr('data-user');
      post._token = $('meta[name="csrf-token"]').attr('content');
      post.is_report = true;

      var url = '/efetuar-inscricao';

      $.ajax({
        type: 'POST',
        url: url,
        data: post,
        dataType: 'json',
        success: function (data) {
          if (data.type === 'success') {
            $subscribesTable.append(data.html);
            $guestsTable.append(data.html);
            $counter.html(data.subscribes);

            Swal.fire(data.title, data.message, data.type);

            $inputAddGuests.text = '';
            $searchPanel.addClass('u-display--none');
          } else {
            Swal.fire(data.title, data.message, data.type);
          }
        },
      });

      return false;
    });

    $(document).on('click', '.js-add-presence-user', function (e) {
      e.preventDefault();

      const form = $(this).closest('form');
      const post = form.serialize();

      if (
        $inputName.val() == '' ||
        $inputEmail.val() == '' ||
        $inputVolunteerType.filter(':checked').val() == null ||
        (
          $inputVolunteerType.filter(':checked').val() == 'employee' &&
          (
            $inputCpf.val() == '' ||
            ($selectCompany.val() == '' || $selectCompany.val() == '0') ||
            ($selectUnity.val() == '' || $selectUnity.val() == '0')
          )
        )
      ) {
        Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
        return false;
      }

      $.ajax({
        type: 'POST',
        url: '/visitante',
        data: post,
        dataType: 'json',
        success: function (data) {
          if (data.type === 'success') {
            $subscribesTable.append(data.html);
            $guestsTable.append(data.html);
            $counter.html(data.subscribes);
            closeAddGuestsForm(e);

            Swal.fire(data.title, data.message, data.type);
          } else {
            Swal.fire(data.title, data.message, data.type);
          }
        },
      });

      return false;
    });
  },
};

export default presencesIndex;
